import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const PageContainer = styled.div`
  width: 210mm;
  max-width: 210mm;
  height: 297mm;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  font-family: ${barnesTheme.fonts.body};
  box-sizing: border-box;
  background-color: ${barnesTheme.colors.white};
  display: flex;
  flex-direction: column;

  @media print {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    position: relative !important;
    height: 297mm !important;
    min-height: 297mm !important;
    max-height: 297mm !important;
    overflow: hidden !important;
    page-break-after: always !important;
    page-break-inside: avoid !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    background-color: ${barnesTheme.colors.white} !important;
  }
`

export const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 8mm ${barnesTheme.spacing.pageMargin} 0
    ${barnesTheme.spacing.pageMargin};

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 8mm ${barnesTheme.spacing.pageMargin} 0
      ${barnesTheme.spacing.pageMargin} !important;
  }
`

export const FooterWrapper = styled.div`
  position: relative;
  margin-top: auto;
  margin-bottom: 0;
  padding-bottom: 0;
  border: none;

  @media print {
    position: relative !important;
    margin-top: auto !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
    border: none !important;
  }
`
